<h1 class="page-title mb-5">انطلق</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            الهيئة العامة للاستثمار والمناطق الحرة هي هيئة اقتصادية عامة لها
            شخصية اعتبارية عامة تنظم الاستثمار في الدولة وتشجعه وتدعمه وتديره
            وتروج له بما يحقق خطة التنمية الاقتصادية للدولة ، ولها أن تنشئ
            فروعاً لها. أو مكاتب داخل جمهورية مصر العربية أو في الخارج بقرار من
            مجلس الإدارة كجزء من بعثات التمثيل التجاري. ​​
          </p>
        </div>

        <ul class="links-nav-cont p-0 m-0" id="pills-tab" role="tablist">
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/investment-systems'" title="الأنظمة الإستثمارية">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/whyegypt1.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title="الأنظمة الإستثمارية"
                  alt="الأنظمة الإستثمارية" />
              </div>
              <span>الأنظمة الإستثمارية</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/BusinessRulesComponent'" title="">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/whyegypt2.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title="الحقائق التجارية" alt="الحقائق التجارية" />
              </div>
              <span>الحقائق التجارية</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/regulations-and-rules'" title=" القوانين واللوائح ">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/whyegypt3.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title=" القوانين واللوائح "
                  alt=" القوانين واللوائح " />
              </div>
              <span>القوانين واللوائح </span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/sites'" title=" مواقع مقترحة">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/infocenter.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title=" مواقع مقترحة" alt=" مواقع مقترحة" />
              </div>
              <span> مواقع مقترحة</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>